import { Action } from '@ngrx/store'
import * as PaymentPurposesTypes from './payment-purposes.types'
import { PaymentPurpose } from './payment-purposes.interface'

// Fetch PaymentPurpose Types
export class FetchPaymentPurposesRequest implements Action {
  readonly type = PaymentPurposesTypes.FETCH_PAYMENT_PURPOSES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchPaymentPurposesSuccess implements Action {
  readonly type = PaymentPurposesTypes.FETCH_PAYMENT_PURPOSES_SUCCESS
  constructor(
    public payload: PaymentPurpose[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchPaymentPurposesFailure implements Action {
  readonly type = PaymentPurposesTypes.FETCH_PAYMENT_PURPOSES_FAILURE
  constructor(public payload: any) {}
}

// Fetch PaymentPurpose Type
export class FetchPaymentPurposeRequest implements Action {
  readonly type = PaymentPurposesTypes.FETCH_PAYMENT_PURPOSE_REQUEST
  constructor(public id: number) {}
}

export class FetchPaymentPurposeSuccess implements Action {
  readonly type = PaymentPurposesTypes.FETCH_PAYMENT_PURPOSE_SUCCESS
  constructor(public payload: PaymentPurpose) {}
}

export class FetchPaymentPurposeFailure implements Action {
  readonly type = PaymentPurposesTypes.FETCH_PAYMENT_PURPOSE_FAILURE
  constructor(public payload: any) {}
}

// Delete PaymentPurpose Type
export class DeletePaymentPurposeRequest implements Action {
  readonly type = PaymentPurposesTypes.DELETE_PAYMENT_PURPOSE_REQUEST
  constructor(public id: number) {}
}

export class DeletePaymentPurposeSuccess implements Action {
  readonly type = PaymentPurposesTypes.DELETE_PAYMENT_PURPOSE_SUCCESS
  constructor() {}
}

export class DeletePaymentPurposeFailure implements Action {
  readonly type = PaymentPurposesTypes.DELETE_PAYMENT_PURPOSE_FAILURE
  constructor(public payload: any) {}
}

// Create PaymentPurpose Type
export class CreatePaymentPurposeRequest implements Action {
  readonly type = PaymentPurposesTypes.CREATE_PAYMENT_PURPOSE_REQUEST
  constructor(public payload) {}
}

export class CreatePaymentPurposeSuccess implements Action {
  readonly type = PaymentPurposesTypes.CREATE_PAYMENT_PURPOSE_SUCCESS
  constructor() {}
}

export class CreatePaymentPurposeFailure implements Action {
  readonly type = PaymentPurposesTypes.CREATE_PAYMENT_PURPOSE_FAILURE
  constructor(public payload: any) {}
}

// Update PaymentPurpose Type
export class UpdatePaymentPurposeRequest implements Action {
  readonly type = PaymentPurposesTypes.UPDATE_PAYMENT_PURPOSE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdatePaymentPurposeSuccess implements Action {
  readonly type = PaymentPurposesTypes.UPDATE_PAYMENT_PURPOSE_SUCCESS
  constructor() {}
}

export class UpdatePaymentPurposeFailure implements Action {
  readonly type = PaymentPurposesTypes.UPDATE_PAYMENT_PURPOSE_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = PaymentPurposesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = PaymentPurposesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdatePaymentPurposeRequest
  | UpdatePaymentPurposeSuccess
  | UpdatePaymentPurposeFailure
  | FetchPaymentPurposesSuccess
  | FetchPaymentPurposesFailure
  | FetchPaymentPurposesRequest
  | FetchPaymentPurposeSuccess
  | FetchPaymentPurposeFailure
  | FetchPaymentPurposeRequest
  | CreatePaymentPurposeRequest
  | CreatePaymentPurposeSuccess
  | CreatePaymentPurposeFailure
  | DeletePaymentPurposeRequest
  | DeletePaymentPurposeSuccess
  | DeletePaymentPurposeFailure
  | SetDefaultData
  | UpdateField
  | FetchPaymentPurposesRequest
  | FetchPaymentPurposesSuccess
  | FetchPaymentPurposesFailure
